export class ValidVideo {
  sdSrc: boolean;
  hdSrc: boolean;

  constructor(sdSrc: boolean, hdSrc: boolean){
    this.sdSrc = sdSrc
    this.hdSrc = hdSrc
  }

  hasVideo() {
    return this.sdSrc || this.hdSrc;
  }
}

export type VideoQuality = "sd" | "hd";
export class VideoSource {
  quality: VideoQuality;
  url: string;

  constructor(quality: VideoQuality, url: string){
    this.quality = quality
    this.url = url
  }
}

export const VIDEOMODE_S = "s";
export const VIDEOMODE_M = "m";
export type VideoMode = typeof VIDEOMODE_S | typeof VIDEOMODE_M;
export class MultiVideoSource {
  type: VideoMode;
  sources: VideoSource[];
  default?: boolean;

  constructor(type: VideoMode, src: VideoSource[], defaultVideo?: boolean){
    this.type = type
    this.sources = src
    this.default = defaultVideo
  }
}

export const isMultiVideoSourceArray = (sources: VideoSource[] | MultiVideoSource[]): sources is MultiVideoSource[] => {
  return sources.length > 0 && sources[0] instanceof MultiVideoSource;    
};
